import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export interface AutocompleteCustomProps {
  options: { label: string; value: string }[];
  optionOther: { label: string; value: string }[];
  value: { label: string; value: string }[];
  onChange: (value: { label: string; value: string }[]) => void;
  setOptionOther: (value: { label: string; value: string }[]) => void;
  label?: string;
  placeholder?: string;
  loading?: boolean;
  error?: boolean;
  helperText?: string;
}

export const AutocompleteCustom: React.FC<AutocompleteCustomProps> = ({
  options,
  optionOther,
  setOptionOther,
  value,
  onChange,
  label,
  placeholder,
  loading,
  error,
  helperText
}) => {
  return (
    <Autocomplete
      multiple
      options={[...optionOther, ...options]}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      filterSelectedOptions
      loading={loading}
      renderOption={(props, option, { selected }) => (
        <li
          {...props}
          style={{
            backgroundColor: selected ? '#e3f2fd' : 'white',
            fontWeight: selected ? 'bold' : 'normal'
          }}>
          {option.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          onBlur={(e) => {
            const input = e.target.value.trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRegex.test(input)) return;
            onChange([...value, { value: e.target.value, label: e.target.value }]);
            if (options.find((item) => item.label === e.target.value)) return;
            if (optionOther.find((item) => item.label === e.target.value)) return;
            setOptionOther([{ value: e.target.value, label: e.target.value }, ...optionOther]);
          }}
        />
      )}
    />
  );
};
